import LeadForm from './LeadForm';

export default function QuickLeadSection() {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              Обсудим задачу оценки под вашу компанию
            </h2>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
              Оставьте заявку — обсудим, зачем компании нужна оценка, какие сотрудники и компетенции должны быть оценены и какое решение должно быть принято по результатам.
            </p>
            <p className="text-sm text-gray-500 leading-relaxed">
              Отвечаю лично в течение одного рабочего дня.
            </p>
          </div>
          <div className="bg-gray-50 rounded-2xl p-5 sm:p-8 border border-gray-100">
            <h3 className="text-lg font-bold text-gray-900 text-center mb-5">Оставьте заявку</h3>
            <LeadForm formId="assessment-lead-early" source="otsenka-i-razvitie-sotrudnikov" />
          </div>
        </div>
      </div>
    </section>
  );
}